export function formatPrice(price_settings: priceSettingsI) {

    let { settings_enabled, standard_price, shopify_price, props, currency_settings } = price_settings;
    let { attribute, price_roundoff_value, value } = standard_price;
    let price: any = {};
    if (settings_enabled) {
        price = calculatePrice({
            attribute: attribute,
            value: value,
            price_roundoff_value: price_roundoff_value ?? false,
            shopify_price: shopify_price
        });

        // if (price?.['calculated_value'] <= 0) {
        //     price['calculated_value'] = 0
        // }
        // else {
        //get currency conversion Value
        let currency_conversion: any = currency_settings;
        let tempValue_type: any = calculatePrice({
            attribute,
            value,
            price_roundoff_value,
            shopify_price
        });
        price = {
            ...price,
            conversion_value_found: currency_conversion != '' && currency_conversion != 0,
            currency_settings: {
                label: 'Currency Conversion',
                attribute: 'currency_conversion',
                conversion_value: `x${currency_conversion}`,
                calculated_value: roundUptoNDecimelPlaces((tempValue_type?.['calculated_value'] * currency_conversion), 2, price_roundoff_value),
            }
        }
        // }
    }
    else {
        price = {
            attribute: 'shopify_price',
            value: shopify_price,
            shopify_price,
            label: 'Shopify Price',
            calculated_value: roundUptoNDecimelPlaces(+shopify_price)
        };
    }
    if (price_roundoff_value && price_roundoff_value?.length > 0) {
        price = {
            ...price,
            price_roundoff_value: price_roundoff_value
        }
    }
    return price
}

export function roundUptoNDecimelPlaces(value: number = 0, decimal_upto: number = 2, price_roundoff_value: any = false) {
    let calculatePrice = value;
    if (price_roundoff_value != undefined && price_roundoff_value != false && price_roundoff_value?.length > 0) {
        return calculateRoundOffPrice(typeof price_roundoff_value === 'string' ? price_roundoff_value : price_roundoff_value?.[0], value);
    } else if (typeof calculatePrice === "number" || typeof calculatePrice === "string")
        return ((+calculatePrice * 100) / 100).toFixed(decimal_upto);
    else
        throw new Error("Data type Error! Only number type is accepted.")
}

function calculateRoundOffPrice(price_roundoff_value: any, calculatedPrices: any) {
    if (typeof calculatedPrices === 'string') {
        calculatedPrices = +calculatedPrices
    }
    let price = 0;
    switch (price_roundoff_value) {
        case 'higherWholeNumber':
            return Number.isInteger(calculatedPrices) ? calculatedPrices : Math.trunc(calculatedPrices + 1);
        case 'higherEndWith9':
            price = (Math.trunc(calculatedPrices) - (Math.trunc(calculatedPrices)) % 10) + 9;
            if (price === Math.trunc(calculatedPrices)) {
                // handle the case 39.44 roundOff
                price += 10;
            }
            return price;
        case 'higherEndWith0.99':
            return Math.trunc(calculatedPrices) + 0.99;
        case 'higherEndWith0.49':
            return Math.trunc(calculatedPrices) + 0.49;
        case 'higherEndWith10':
            price = (Math.trunc(calculatedPrices) - (Math.trunc(calculatedPrices)) % 10);
            return price + 10;
        case 'lowerWholeNumber':
            return Number.isInteger(calculatedPrices) ? calculatedPrices : (Math.floor(calculatedPrices));
        case 'lowerEndWith9':
            price = (Math.trunc(calculatedPrices) - (Math.trunc(calculatedPrices)) % 10) - 1;
            if ((price + 10) === Math.trunc(calculatedPrices)) {
                // handle the case 39.44 roundOff
                return price + 10;
            } else {
                return price;
            }
        case 'lowerEndWith0.99':
            price = Math.trunc(calculatedPrices - 1);
            if (calculatedPrices == 1) {
                return 0.99
            } else if (calculatedPrices <= 0.99) {
                return calculatedPrices
            } else {
                return price + 0.99;
            }
        case 'lowerEndWith0.49':
            price = Math.trunc(calculatedPrices - 1);
            if (calculatedPrices == 1) {
                return 0.49
            } else if (calculatedPrices <= 0.49) {
                return calculatedPrices
            } else {
                return price + 0.49;
            }
        case 'lowerEndWith10': price = (Math.trunc(calculatedPrices) - (Math.trunc(calculatedPrices)) % 10);
            return price;
        default: return calculatedPrices;
    }
}

function calculatePrice(calculatedPrice: calculatedPriceI) {
    let { attribute, value, price_roundoff_value, shopify_price } = calculatedPrice;

    if (!attribute) return { calculated_value: 0 }
    if (attribute?.toLowerCase() === 'default')
        return {
            attribute: attribute,
            value: value,
            calculated_value: +shopify_price,
            shopify_price,
            label: 'Default',
        }
    else if (attribute?.toLowerCase() === 'value_increase')
        return {
            attribute: attribute,
            value: value,
            calculated_value: +shopify_price + +value,
            shopify_price,
            label: 'Value Increase',
            formatted_price: `+${value}`
        }
    else if (attribute?.toLowerCase() === 'value_decrease')
        return {
            attribute: attribute,
            value: value,
            calculated_value: +shopify_price - +value,
            shopify_price,
            label: 'Value Decrease',
            formatted_price: `-${value}`
        }
    else if (attribute?.toLowerCase() === 'percentage_increase')
        return {
            attribute: attribute,
            value: value,
            calculated_value: +shopify_price + ((+value / 100) * +shopify_price),
            shopify_price,
            label: 'Percentage Increase',
            formatted_price: `+${value}%`
        }
    else if (attribute?.toLowerCase() === 'percentage_decrease')
        return {
            attribute: attribute,
            value: value,
            calculated_value: +shopify_price - ((+value / 100) * +shopify_price),
            shopify_price,
            label: 'Percentage Decrease',
            formatted_price: `-${value}%`
        }
    else return { calculated_value: 0 };
}

interface priceSettingsI {
    props: any
    settings_enabled: boolean
    standard_price: any
    shopify_price: number
    auxillary?: any
    currency_settings: string | number
}

interface calculatedPriceI {
    attribute: string,
    value: number
    shopify_price: number
    price_roundoff_value: any
}

export function getPriceValue(price: any) {
    if (price?.['conversion_value_found'])
        return price?.['currency_settings']?.['calculated_value'] ?? 'N/A'
    else
        return price?.calculated_value ?? 'N/A'
}